<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="row">
                            <div class="col-sm-12">
                                <h3 class="text-center" style="margin-top:0; margin-bottom: 20px">
                                    Details voor {{customer.companyName}}
                                </h3>
                                <form v-if="customer.id" @submit.prevent="editCustomer()">
                                    <div class="row mb-20">
                                        <div class="col-sm-12">
                                            <div class="col-sm-4">
                                                <label>Debiteurnummer*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.debtorNumber">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Bedrijfsnaam*</label>
                                                <input type="text"
                                                       required
                                                       class="form-control"
                                                       v-model="customer.companyName">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Naam*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.name">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-20">
                                        <div class="col-sm-12">
                                            <div class="col-sm-4">
                                                <label>Adres*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.address">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Postcode*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.zipCode">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Plaatsnaam*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.city">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-20">
                                        <div class="col-sm-12">
                                            <div class="col-sm-4">
                                                <label>Email*</label>
                                                <input type="email"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.email">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Facturering email*</label>
                                                <input type="email"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.invoiceEmail">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Land*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.country">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-20">
                                        <div class="col-sm-12">
                                            <div class="col-sm-4">
                                                <label>Kvk*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.kvk">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Telefoon*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       required
                                                       v-model="customer.phoneNumber">
                                            </div>
                                            <div class="col-sm-4">
                                                <label>Ordermail ook sturen naar:*</label>
                                                <input type="text"
                                                       class="form-control"
                                                       v-model="customer.extraOrderMail">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="col-sm-4">
                                                <button type="submit" class="btn btn-danger">Opslaan</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>


                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-sm-12">
                                        <h3 class="text-center">Mijn orders overnemen</h3>
                                        <p class="text-center">Hier kun je de orders van een andere klant overnemen naar deze klant.</p>
                                        <div class="col-sm-offset-4 col-sm-3">
                                            <vue-select v-model="customerToCopyOrderItemsFrom" :options="customersDropdown"></vue-select>
                                        </div>
                                        <div>
                                            <button class="btn btn-danger" @click="copyOrderItemsFromCustomer()">kopiëren</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr>
                                    </div>
                                </div>



                                <form @submit.prevent="saveCustomerSpecificPrices()">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <h3 class="text-center">Klantspecifieke prijzen (€)</h3>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-offset-3 col-sm-3">
                                                        <strong>Artikelnummer*</strong>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <strong>Prijs*</strong>
                                                    </div>
                                                    <div class="col-sm-3">
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-for="(customerSpecificPrice, index) in customerSpecificPrices">
                                                <div class="row" style="margin-top:5px;">
                                                    <div class="col-sm-12">
                                                        <div class="col-sm-offset-3 col-sm-3">
                                                            <input title="artikelnummer" required v-model="customerSpecificPrice.articleNumber" class="form-control">
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <input title="Prijs" type="number" step="0.01" min="0" v-model="customerSpecificPrice.price" required placeholder="..." class="form-control">
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <i class="glyphicon glyphicon-trash align-middle" @click="removeCustomerSpecificPrice(index)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="col-sm-offset-3 col-sm-12" style="margin-top: 20px;">
                                                <button type="submit" class="btn btn-danger">Opslaan</button>
                                                <button type="button" class="btn btn-success" @click="addCustomerSpecificPrice()">Prijs toevoegen</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>


                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr>
                                    </div>
                                </div>


                                <form @submit.prevent="saveDiscount()">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <h3 class="text-center">Categorie kortingen (%)</h3>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-offset-3 col-sm-3">
                                                        <strong>Code*</strong>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <strong>Korting*</strong>
                                                    </div>
                                                    <div class="col-sm-1">
                                                        <strong>Actief</strong>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-for="code in discounts">
                                                <div class="row" style="margin-top:5px;">
                                                    <div class="col-sm-12">
                                                        <div class="col-sm-offset-3 col-sm-3">
                                                            <vue-select v-model="code.code" :options="codes"></vue-select>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <input title="discount" type="number" step="0.1" min="0" v-model="code.discount" required placeholder="..." class="form-control">
                                                        </div>
                                                        <div class="col-sm-1">
                                                            <input title="active" type="checkbox" v-model="code.active" style="margin-top: 10px">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="col-sm-offset-3 col-sm-12" style="margin-top: 20px;">
                                                <button type="submit" class="btn btn-danger">Opslaan</button>
                                                <button type="button" class="btn btn-success" @click="addDiscount()">Korting toevoegen</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from '../BTFooter.vue'
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'
    import VueSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: 'EditCustomer',
        components: {
            BtFooter,
            VueSelect
        },
        created() {
            this.$store.dispatch('getCustomer', this.$route.params.id)
            this.$store.dispatch('getCustomers')
            this.$store.dispatch('getDiscountsForCustomer', this.$route.params.id)
            this.$store.dispatch('getPricesForCustomer', this.$route.params.id)
            this.$store.dispatch('getCategoryCodes')
        },
        data() {
            return {
                customerToCopyOrderItemsFrom: ''
            }
        },
        methods: {
            copyOrderItemsFromCustomer() {
                if (this.customerToCopyOrderItemsFrom !== '') {
                    this.$swal({
                        title: 'Let op!',
                        text: 'Je staat op het punt om "mijn orders" van deze klant te overschrijven met die van iemand anders! Weet je het zeker?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Kopiëren',
                        cancelButtonText: 'Annuleren'
                    }).then((result) => {
                        if (result) {
                            this.$store.dispatch('copyOrderItemsFromCustomer', { from: this.customerToCopyOrderItemsFrom, to: this.customer.id }).then(() => {
                                if (this.orderItemsAreCopied) {
                                    this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Mijn orders zijn overgenomen!' })
                                } else {
                                    this.$notify({
                                        group: 'danger',
                                        type: 'error',
                                        title: 'Error',
                                        text: 'Er is iets fout bij het overnemen van "mijn orders" van een andere klant!'
                                    })
                                }
                            })
                        }
                    })
                } else {
                    this.$notify({
                        group: 'danger',
                        type: 'error',
                        title: 'Error',
                        text: 'Er is geen andere klant geselecteerd!'
                    })
                }
            },
            editCustomer() {
                this.$store.commit(types.SET_CUSTOMER_TO_EDIT, this.customer)
                this.$store.dispatch('editCustomer').then(() => {
                    if (this.isCustomerUpdated) {
                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Klant is aangepast!' })
                    } else {
                        this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets fout gegaan bij het opslaan van deze klant!' })
                    }
                })
            },
            addDiscount() {
                this.$store.commit(types.ADD_DISCOUNT_TO_DISCOUNTS, { code: '', discount: '', active: true })
            },
            addCustomerSpecificPrice() {
                this.$store.commit(types.ADD_PRICE_TO_CUSTOMER_SPECIFIC_PRICES, { articleNumber: '', price: '' })
            },
            removeCustomerSpecificPrice(index) {
                this.$store.commit(types.REMOVE_PRICE_TO_CUSTOMER_SPECIFIC_PRICES, { index: index })
            },
            saveDiscount() {
                this.$store.commit(types.SET_DISCOUNT_TO_CREATE, { customerId: this.customer.id, codes: this.discounts })
                this.$store.dispatch('createUpdateDiscount').then(() => {
                    if (this.isDiscountCreated) {
                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Kortingen zijn toegepast!' })
                    } else {
                        this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets foutgegaan bij het opslaan van de kortingen!' })
                    }
                })
            },
            saveCustomerSpecificPrices() {
                this.$store.commit(types.SET_CUSTOMER_SPECIFIC_PRICES_TO_CREATE, { customerId: this.customer.id, customerSpecificPrices: this.customerSpecificPrices })
                this.$store.dispatch('createUpdateCustomerSpecificPrices').then(() => {
                    if (this.isCustomerSpecificPricesCreated) {
                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Prijzen zijn toegepast!' })
                    } else {
                        this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets foutgegaan bij het opslaan van de prijzen!' })
                    }
                })
            }
        },
        computed: {
            ...mapGetters({
                customer: 'customer',
                customers: 'customers',
                orderItemsAreCopied: 'orderItemsAreCopied',
                isCustomerUpdated: 'isCustomerUpdated',
                isDiscountCreated: 'isDiscountCreated',
                categoryCodes: 'categoryCodes',
                customerSpecificPrices: 'customerSpecificPrices',
                isCustomerSpecificPricesCreated: 'isCustomerSpecificPricesCreated',
                discounts: 'discounts'
            }),
            codes() {
                return this.categoryCodes.map((code) => {
                    return code.categoryCode
                })
            },
            customersDropdown() {
                return this.customers.map((customer) => {
                    return customer.debtorNumber
                })
            }
        }
    }
</script>

<style scoped>
    .mb-20 {
        margin-bottom: 20px;
    }

    .glyphicon {
        cursor: pointer;
    }
</style>
